module.exports = __webpack_public_path__ + "static/media/11_blanco.01140a15.svg";